import React, {useEffect, useState} from 'react'
import {change, Field, FieldArray, getFormValues, reduxForm} from 'redux-form'
import {Button, Col, Container, Form as BootstrapForm, Row, Spinner, Table} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {ListService, PenaltyService} from "../../services";
import AddOptionsFormPane from "../OptionsManagement/AddOptionsFormPane";

const renderInput = ({ input, type, placeholder,  readOnly }) => (
  <BootstrapForm.Control {...input} type={type} placeholder={placeholder}   readOnly={readOnly}/>
)

const renderSelect = ({ input, options, loading }) => (
  <BootstrapForm.Select {...input} disabled={loading}>
    <option value="">Select Item Number</option>
    {options.map((opt) => (
      <option key={opt.id} value={opt.id}>
        {opt.label}
      </option>
    ))}
  </BootstrapForm.Select>
)

const renderItems = ({ fields }) => (
  <Table bordered hover>
    <thead>
      <tr>
        <th>Reason</th>
        <th>Cost (₹)</th>
      </tr>
    </thead>
    <tbody>
      {fields.map((item, index) => (
        <tr key={index}>
          <td>

              <span style={{

              }}><Field name={`${item}.reason`} readOnly   component={renderInput} placeholder="Reason" /></span>
          </td>
          <td>
            <Field name={`${item}.cost`} component={renderInput} type="number" placeholder="Cost" />
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
)

const PenaltyForm = ({ handleSubmit }) => {
    const [canSubmit, setCanSubmit] = useState(true)
  const [itemOptions, setItemOptions] = useState([])
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {

init()
  }, [])

  const init = async ()=>{
       const res = await new ListService().makeGetRequest({"list_name": "LOANER_INVENTORY_PART_NUMBERS"})


      const transformed = res.results.map((item) => ({
            id: item.value, // example: "ITEM001"
            label: item.value,
            }))
          setItemOptions(transformed)
          setLoading(false)
  }
const createRawValues = async () => {
    setCanSubmit(true);
  const res = await new ListService().makeGetRequest({
    list_name: 'LOANER_INVENTORY_PENALTY_REASONS',
  })

  const penalties = res.results.sort((a, b) => a.value.localeCompare(b.value)).map((item) => ({
    reason: item.value,
    cost: 0,
  }))

  setLoading(false)
  dispatch(change('loanerPenaltyForm', 'items', penalties))
}
  const onItemChange = async (e) => {
        const selectedItem = e.target.value
    dispatch(change('loanerPenaltyForm', 'item_number', selectedItem))
       if (selectedItem) {
    try {
      const res = await new PenaltyService().makeGetRequest({ part_number: selectedItem });
         if(!res?.results?.length){
         await createRawValues()
         return
     }
  const penalties = res.results
  .sort((a, b) => a.reason.localeCompare(b.reason))
  .map((item) => ({
    part_number: item.part_number,
    reason: item.reason,
    cost: item.cost,
  }));
      setLoading(false)
         setCanSubmit(false);

      dispatch(change('loanerPenaltyForm', 'items', penalties));
    } catch (error) {
      console.error("Error fetching penalties", error);
    }
  } else {
    // If cleared, also clear the items
    dispatch(change('loanerPenaltyForm', 'items', []));
  }

  }

  return (
    <Container>
      <h3 className="my-3">Create Loaner Item Penalty Amounts</h3>
      <BootstrapForm onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={12}>
            <BootstrapForm.Label>Part Number</BootstrapForm.Label>
            <Field
              name="item_number"
              component={({ input }) =>
                renderSelect({ input: { ...input, onChange: onItemChange }, options: itemOptions, loading })
              }
            />
            {loading && <Spinner animation="border" size="sm" className="mt-2" />}
          </Col>

        </Row>
            <Row>
                <Col className={" mb-3 text-end"} xs={12}>
                 <AddOptionsFormPane selectedType={"LOANER_INVENTORY_PART_NUMBERS"} title={"Add New Part Number"} OnSuccess={()=>{
               init()
           }}/>
                    </Col>
            </Row>


        <FieldArray name="items" component={renderItems} />

          {canSubmit && <Row>
          <Col className="text-end">
            <Button type="submit" variant="dark">Submit</Button>
          </Col>
        </Row>}
      </BootstrapForm>
    </Container>
  )
}

export default reduxForm({
  form: 'loanerPenaltyForm',
})(PenaltyForm)
